export default import.meta.ROLLDOWN_FILE_URL_KaVhzXkzjufM$V9UGX96eQ